import { Component, HostListener, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { DraggablemodalhotlineComponent } from '../draggablemodalhotline/draggablemodalhotline.component';

@Component({
  selector: 'app-hotline',
  templateUrl: './hotline.component.html',
  styleUrls: ['./hotline.component.scss']
})
export class HotlineComponent implements OnInit {
  public submit=true
  public informa=false
  public hintstips=false
  public infoclick:any
  public hintsclick:any
  public submitclick:any
  public showsecondhot=true;
  public showfirsthot=false;
  public isBackToTopShowBtn: boolean = false;

  constructor(private modalService: NgbModal,private service: ApifirstService) { }

  ngOnInit(): void {
      this.service.infotab.subscribe((data) => {
        this.informa = data
      })
      this.service.hintstab.subscribe((data) => {
        this.hintstips = data
      })
      this.service.submittab.subscribe((data) => {
        this.submit = data
      })
      this.showsecondhot=false;
      this.showfirsthot=true;

  }
  openModal(){
    const modalRef = this.modalService.open(DraggablemodalhotlineComponent, { windowClass : "myCustomModalClasshotline"
     });
     modalRef.result.then(
         result => {
             console.log(result);
         },
         reason => {}
     );
  }
  submitCase(){
    this.submit=true
    this.informa=false
    this.hintstips=false
  }
  hintsAndTips(){
    this.submit=false
    this.informa=false
    this.hintstips=true
  }
  information(){
    this.submit=false
    this.informa=true
    this.hintstips=false
    this.showfirsthot=true
    this.showsecondhot=false;
  }
  linkForTechHotline(){
    this.showsecondhot=true;
    this.showfirsthot=false;
  }
  onClickBack(){
    this.showfirsthot=true;
    this.showsecondhot=false;
  }
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
  /* for window scroll up */
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
}
